module.exports = __webpack_public_path__ + "static/aboutFabricsthan1-34541dc7dd95d94a49318cb3935de621.png";